<template>
  <div>
    <common-dialog
      ref="dialog"
      width="900px"
      :show-save-button="false"
      unit="安全员"
      edit-title
      form-label-width="125px"
      id-key="DpId"
      :data="data"
      :form-rules="rules"
      :get-data-func="api.info"
      :save-func="isSubmit?api.submit:api.save"
      @details-opened="onDetailsOpened"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      :before-close="handleBeforeClose"
      :before-save="onBeforeSave"
      close-on-saved
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        基础信息
        <el-row class="row-border">
          <el-row>
            <el-col :span="12">
              <el-col :span="24">
                <el-form-item label="归属机构" prop="DpId">
                  <tree-select
                    ref="treeSelect"
                     
                    :props="props"
                    :options="TreeData"
                    :value="data.DpId"
                    :clearable="true"
                    :accordion="true"
                    :parentSelect="true"
                    placeholder="请选择"
                    @node-select="onTreeSelect($event)"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="姓名" prop="FullName">
                  <el-input v-model="data.FullName" placeholder="请填写姓名"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="性别" prop="Sex">
                  <el-select v-model="data.Sex">
                    <el-option :value="1" label="男"/>
                    <el-option :value="2" label="女"/>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="身份证号" prop="IdCard">
                  <el-input v-model="data.IdCard" @blur="getBirth(data.IdCard)" placeholder="请填写身份证号"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="出生日期" prop="BirthDate">
                  {{$commonJs.toDateString(data.BirthDate)}}
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="手机号码" prop="Mobile">
                  <el-input v-model="data.Mobile" type="number" maxlength="11" placeholder="请填写手机号码"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="联系地址" prop="Address">
                  <el-input v-model="data.Address" placeholder="请填写联系地址"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="准驾车型" prop="DriveCarType">
                  <el-select v-model="data.DriveCarType">
                    <el-option v-for="item in driveList" :key="item.DataId" :value="item.DataName"/>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="准教车型" prop="TeachCarType">
                  <el-select v-model="data.TeachCarType">
                    <el-option v-for="item in teachList" :key="item.DataId" :value="item.DataName"/>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="驾驶证号" prop="DriveNo">
                  <el-input v-model="data.DriveNo" placeholder="请填写驾驶证号"></el-input>
                </el-form-item>
              </el-col>
            </el-col>
            <el-col :span="12">
              <el-col :span="24">
                <photograph ref="photograph" v-model="data.CertUrl" />
                <div class="uploadText">
                  <p>照片要求</p>
                  <p>1、证件照可上传或者连接摄像头现场拍摄</p>
                  <p>2、上传或拍摄照片要求为白底免冠</p>
                  <p>3、上传的照片大小不超过高377px*宽307px</p>
                  <p>4、图片大小500k之内</p>
                </div>
              </el-col>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="驾驶证初领日期" prop="DriveDate">
                <el-date-picker
                   
                  v-model="data.DriveDate"
                  placeholder="请选择日期"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="入职日期" prop="InDate">
                <el-date-picker
                   
                  v-model="data.InDate"
                  placeholder="请选择日期"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="任职类型" prop="InType">
                <el-select v-model="data.InType">
                  <el-option :value="0" label="自有"/>
                  <el-option :value="1" label="加盟"/>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="任职状态" prop="InStatus">
                <el-select v-model="data.InStatus">
                  <el-option :value="0" label="在职"/>
                  <el-option :value="1" label="离职"/>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="备注" prop="Remark">
                <el-input type="textarea" v-model="data.Remark" placeholder="请填写备注"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
      </template>
      <template #footer>
        <el-button type="warning" @click="toSave(0)">保 存</el-button>
        <el-button type="primary" v-if="data.Status==0||data.Status==2" @click="toSave(1)">提 交</el-button>
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import treeSelect from "@/components/common/treeSelect";
import photograph from "@/components/common/photograph";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    treeSelect,
    photograph
  },
  data() {
    return {
      data: {
        CoachId: 0,
        DpId: 0,
        DpName: "",
        FullName: "",
        Sex: null,
        IdCard: "",
        BirthDate: "",
        Mobile: "",
        Address: "",
        DriveCarType: "",
        TeachCarType: "",
        DriveNo: "",
        DriveDate: "",
        InDate: "",
        InType: null,
        InStatus: null,
        Remark: "",
        CertUrl: "",
        Status: 0,
        CoachType: 1,
      },
      api: require("@/api/schoolmanage/coach").default,
      dpApi: require("@/api/basic/dp").default,
      basicApi: require("@/api/basic/data").default,
      TreeData: [],
      driveList: [],
      teachList: [],
      // DriveCarType: [],
      // TeachCarType: [],
      headers: { Authorization: "" },
      props: {
        value: "DpId",
        label: "DpName",
        children: "children",
      },
      isSubmit: false,
      isMB: this.$store.state.isMB,
      rules: {
        DpId: [{ required: true, message: "请选择归属机构" }],
        FullName: [{ required: true, message: "请填写姓名" }],
        Sex: [{ required: true, message: "请选择性别" }],
        IdCard: [
          { required: true, message: "请填写身份证号" },
          { validator: this.$commonJs.validateRules.idCard },
        ],
        // BirthDate: [{ required: true, message: "请选择出生日期" }],
        Mobile: [
          { required: false, message: "请填写手机号码" },
          { validator: this.$commonJs.validateRules.validPhone },
        ],
        // DriveCarType: [{ required: true, message: "请选择准驾车型" }],
        // TeachCarType: [{ required: true, message: "请选择准教车型" }],
        DriveNo: [{ required: true, message: "请填写驾驶证号" }],
        DriveDate: [{ required: true, message: "请选择驾驶证初领日期" }],
        InDate: [{ required: true, message: "请选择入职日期" }],
        InType: [{ required: true, message: "请选择任职类型" }],
        InStatus: [{ required: true, message: "请选择任职状态" }],
      },
    };
  },
  computed: {
    host() {
      return window.location.origin;
    }
  },
  methods: {
    onCreateOpened(data) {
      this.getBasic();
      this.getTreeData();
    },
    onEditOpened(data) {
      this.getBasic();
      this.getTreeData();
      // if(data.DriveCarType) {
      //   this.DriveCarType = data.DriveCarType.split(",");
      // }
      // if(data.TeachCarType) {
      //   this.TeachCarType = data.TeachCarType.split(",");
      // }
    },
    onDetailsOpened(data) {
      this.onEditOpened(data);
    },
    getTreeData() {
      this.dpApi.getAuthList({ DpTypes: [2,3], Status: 3, NoReturnParent: true }).then((res) => {
        this.TreeData = this.$commonJs.toTreeData(res.Data, "DpId");
        if(this.data.DpId) {
          this.$refs.treeSelect.setData(this.data.DpId);
        }
      });
    },
    onTreeSelect(t) {
      if (!t) {
        this.data.DpId = 0;
        this.data.DpName = "";
      } else {
        this.data.DpId = t.DpId;
        this.data.DpName = t.DpName;
      }
    },
    getBasic() {
      this.driveList = [];
      this.teachList = [];
      this.basicApi.list({ClassName:"准教车型", Status:1}).then(res => {
        this.driveList = res.Data;
        this.teachList = res.Data;
      });
    },
    toSave(type) {
      this.isSubmit = type==1;
      this.save();
    },
    onBeforeSave(data) {
      if(!this.data.DpId) {
        this.$message.error("请选择归属机构");
        return false;
      }
      if(!this.data.CertUrl) {
        this.$message.error("请添加证件照");
        return false;
      }
      this.$refs.photograph.clear();
    },
    getBirth(idCard) {
      var birthday = "";  
      if(idCard != null && idCard != "") {  
          if(idCard.length == 15){  
              birthday = "19"+idCard.substr(6,6);  
          } else if(idCard.length == 18){  
              birthday = idCard.substr(6,8);  
          }
          birthday = birthday.replace(/(.{4})(.{2})/,"$1-$2-");  
      }
      this.data.BirthDate = birthday||"";
    },
    handleBeforeClose() {
      this.$refs.photograph.clear();
      this.$nextTick(() => {
        this.close(true);
      });
    },
    onClosed() {
      this.$refs.treeSelect.clearHandle();
      // this.TeachCarType = [];
      // this.DriveCarType = [];
      this.TreeData = [];
      this.$refs.photograph.clear();
    },
  },
};
</script>
<style lang="scss">
.uploadText{
  margin-left: 82px;
  color: red;
  line-height: 14px;
}
</style>